import { Box, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  fontSize: 'sm',
  lineHeight: 'sm',
  letterSpacing: '0.5px',
  width: '47%',
  padding: '$1',
  paddingX: '$3',
  borderWidth: '2px',
  fullWidth: false,
  height: '$12',
});

export const StyledWrapper = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-around',
  marginY: '$4',
  marginX: '$2',
});
